"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsPanelResponseMapper = void 0;
var TermsPanelResponseMapper = /** @class */ (function () {
    function TermsPanelResponseMapper(data) {
        this.localData = data;
    }
    TermsPanelResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return TermsPanelResponseMapper;
}());
exports.TermsPanelResponseMapper = TermsPanelResponseMapper;
//# sourceMappingURL=TermsPanelResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/TermsPanelResponseMapper.js
// module id = 2081
// module chunks = 8